import { HDM_SEARCH_SEO_PATHS } from '@/data/constants/urlPathConstants';

const paths: string[] = [HDM_SEARCH_SEO_PATHS.Search];

export const filterDynamicPaths = (path: string[]) => {
	if (Array.isArray(path) && paths.includes(path[0])) {
		return [path[0]];
	}
	return path;
};
